var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border border-gray-200 | flex flex-col md:flex-row"},[_c('div',{staticClass:"w-full p-2 md:p-0 md:w-12 bg-gray-100 flex md:items-center md:justify-center"},[_c('fa-icon',{attrs:{"icon":_vm.icon,"fixed-width":""}})],1),_c('div',{staticClass:"flex-1 p-2 pl-4"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }